import { gql } from '@apollo/client';

export const REINVITE_PATIENT = gql`
  mutation($record: ReinvitePatientInput!) {
    user {
      patientUser {
        reinvitePatient(record: $record) {
          ok
          error {
            message
            code
          }
          resultId
          result {
            id
            name {
              firstName
              lastName
            }
          }
        }
      }
    }
  }
`;
